
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[...path]",
      function () {
        return require("private-next-pages/catalog/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/[...path]"])
      });
    }
  